import {RestRequestPOST, RestRequestGET, RestRequestPUT, RestRequestDELETE} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {setSaveStatusError, setResource} from "../redux/actions";
import Endpoints from "../constants/Endpoints";
import validateSection from './helpers/validateSection'
import Tr from "../translations/Translations";
import {DemandValidation} from "../constants/DemandValidation";

const TIMEOUT_MS = 120000;
const pendingRequests = new Map();

const showError = (message) => {
    reduxStore.dispatch(setSaveStatusError(message))
}

const generateLink = async (demandId) => {
	try {
        return await RestRequestPOST(Endpoints.ENOTICES_GENERATE_LINK(demandId));
	} catch (e) {
		console.error(e);
	}
	return {uploadStatus: "ERROR"}
}

const createNotice = async (demandId) => {
	try {
        const res = await RestRequestPOST(Endpoints.ENOTICES_CREATE(demandId));
        await getNoticeStatusTed(demandId, DemandValidation.ENOTICES2);
        return res
    } catch (e) {
		console.error(e);
	}
	return {uploadStatus: "ERROR"}
}

const createChangeNotice = async (demandId) => {
	try {
        const res = (await RestRequestPOST(Endpoints.ENOTICES_CREATE_CHANGE(demandId))).result;
	    await getNoticeStatusTed(demandId, DemandValidation.ENOTICES2);
        return res
	} catch (e) {
		console.error(e);
	}
	return {uploadStatus: "ERROR"}
}

export const getNoticeStatusTed = (demandId, demandValidationSectionId) =>
    fetchEnoticeStatus(
        Endpoints.ENOTICES_VALIDATE_TED,
        demandId,
        demandValidationSectionId
    );

export const getNoticeStatusTedLocal = async (demandId) => {
    try {
        const { result: res } = await RestRequestGET(Endpoints.ENOTICES_VALIDATE_TED_LOCAL(demandId));
        if (isResponseValid(res, showError)) {
            reduxStore.dispatch(
                setResource('enoticeStatus', res)
            );
            return res;
        }
    } catch (e) {
        console.error(e);
    }
    return { uploadStatus: "ERROR" };
}

export const getAnnouncementStatus = (demandId, demandValidationSectionId) =>
    fetchEnoticeStatus(
        Endpoints.ENOTICES_ANNOUNCEMENT_STATUS,
        demandId,
        demandValidationSectionId
    );

const withdrawNotice = async (demandId) => {
        try {
    		 return await RestRequestPUT(Endpoints.ENOTICES_WITHDRAW(demandId));
    	} catch (e) {
    		console.error(e);
    	}
    	return {uploadStatus: "ERROR"}
}

const publishNotice = async (demandId, preferredPublicationDate = null) => {
    try {
        const res =  await RestRequestPUT(Endpoints.ENOTICES_PUBLISH(demandId), {
            preferredPublicationDate: preferredPublicationDate
        });
        if(!res.success) {
            reduxStore.dispatch(setSaveStatusError(Tr('enotice_publish_request_error')));
            return;
        }
        return res;
   	} catch (e) {
   		console.error(e);
   	}
   	return {uploadStatus: "ERROR"}
}

const renderNotice = async (demandId) => {
    try {
        const resp = await RestRequestGET(
            Endpoints.ENOTICES_RENDER(demandId),
            {
                responseType: 'blob',
                headers: { Accept: 'application/pdf' }
            }
        );

        if (!resp) {
            return;
        }
        const blob = resp instanceof Blob ? resp : new Blob([resp], { type: 'application/pdf' });
        if (blob.size === 0) {
            return;
        }
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
    } catch (e) {
        console.error("Error:", e);
    }
};

const validate = async (demandId) => {
    return RestRequestGET(Endpoints.ENOTICES_VALIDATE(demandId));
}

export const fetchEnoticeStatus = async (endpoint, demandId, demandValidationSectionId) => {
  const key = `${demandId}__${demandValidationSectionId || 'default'}`;

  if (pendingRequests.has(key)) {
    return pendingRequests.get(key);
  }

  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error(`Notice status request timed out after ${TIMEOUT_MS}ms`));
    }, TIMEOUT_MS);
  });

  const req = Promise.race([RestRequestGET(endpoint(demandId)), timeoutPromise])
    .then(async (response) => {
      const res = response?.result;

      if (!res || !isResponseValid(res, showError)) {
        return { uploadStatus: "ERROR" };
      }
      reduxStore.dispatch(setResource('enoticeStatus', res));
      if (demandValidationSectionId)
        await validateSection(demandValidationSectionId, demandId, false);
      return res;
    })
    .catch((error) => {
      console.error("Error fetching eNotice status:", error);
      return { uploadStatus: "ERROR" };
    })
    .finally(() => {
      pendingRequests.delete(key);
    });

  pendingRequests.set(key, req);
  return req;
};

const deleteNotice = async (demandId) => {
    try {
        return (await RestRequestDELETE(Endpoints.ENOTICES_DELETE(demandId))).result;
   	} catch (e) {
   		console.error(e);
   	}
   	return {uploadStatus: "ERROR"}
}

const validateEnoticeSection = async (demandId) => {
    await validateSection(DemandValidation.ENOTICES2, demandId, false);
}

export default {
    createNotice,
    createChangeNotice,
    generateLink,
    getNoticeStatusTed,
    getNoticeStatusTedLocal,
    getAnnouncementStatus,
    publishNotice,
    withdrawNotice,
    validate,
    renderNotice,
    deleteNotice,
    validateEnoticeSection
};

